import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import {
  dataGridTextSorter,
  dataGridDateSorter,
  dataGridSurnameSorter,
} from '../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { useDataGridDateRangeFilter } from '../../../../common/DataGrid/filters/useDataGridDateRangeFilter.jsx';

const DissertationsTable = ({ dissertations, onDetailClick, onDelete }) => {
  const { t } = useTranslation();

  const studentTextFilterProps = useDataGridTextFilter('student');
  const titleTextFilterProps = useDataGridTextFilter('title');
  const supervisorTextFilterProps = useDataGridTextFilter('supervisor');
  const yearDateRangeFilterProps = useDataGridDateRangeFilter('year');
  const studyProgramTextFilterProps = useDataGridTextFilter('studyProgramName');

  const columns = useMemo(
    () => [
      {
        title: t('Autor práce'),
        dataIndex: 'student',
        ellipsis: true,
        ...studentTextFilterProps,
        sorter: dataGridSurnameSorter('student'),
      },
      {
        title: t('Názov práce'),
        dataIndex: 'title',
        ellipsis: true,
        ...titleTextFilterProps,
      },
      {
        title: t('Školiteľ'),
        dataIndex: 'supervisor',
        ellipsis: true,
        ...supervisorTextFilterProps,
        sorter: dataGridSurnameSorter('supervisor'),
      },
      {
        title: t('Dátum obhajoby'),
        dataIndex: 'year',
        sorter: dataGridDateSorter('year'),
        render: (date) => (date && new Date(date).toLocaleDateString()) || '-',
        ...yearDateRangeFilterProps,
        width: 200,
      },
      {
        title: t('Študijný program'),
        dataIndex: 'studyProgramName',
        ellipsis: true,
        ...studyProgramTextFilterProps,
      },
    ],
    [
      studentTextFilterProps,
      studyProgramTextFilterProps,
      supervisorTextFilterProps,
      t,
      titleTextFilterProps,
      yearDateRangeFilterProps,
    ],
  );

  return (
    <DataGrid
      rowKey={(dissertation) => dissertation.id}
      columns={columns}
      dataSource={dissertations || []}
      permissionsBasic={'dissertations'}
      uniqueTableId={'dissertations-table'}
      onRowClick={onDetailClick}
      onEditClick={onDetailClick}
      showActionText={false}
      optionsWidth={112}
      onDelete={onDelete}
    />
  );
};

DissertationsTable.propTypes = {
  dissertations: PropTypes.array,
  onDetailClick: PropTypes.func,
  onDelete: PropTypes.func,
  onCreateClick: PropTypes.func,
};

export default DissertationsTable;
